import { Output, EventEmitter } from '@angular/core';
import { CurrentUser } from './models/current-user.model';
import { ContainerService } from './services/container.service';
import { Subscription } from 'rxjs/Subscription';
import { StorageService } from './storage.service';
import { StatusProcessService } from './services/status-process.service';
import { io } from 'socket.io-client';
import { environment } from '../environments/environment';
import { Socket } from 'socket.io-client/build/socket';
import { CurrencyMaskConfig } from 'ng2-currency-mask/src/currency-mask.config';

type Callback<T1, T2 = void> = (param: T1) => T2;

/**
 * @internal
 */
export class AppBase extends StorageService {
  currentUser: CurrentUser = null;
  localeSettings = null;
  currentCommunityName: any;
  currentCommunityImg: any;
  addressCommunity: any;
  localCodeCommunity: any;
  langDataTables: any;
  customCurrencyMaskConfig: CurrencyMaskConfig;

  public dtOptions: DataTables.Settings = {};
  public subscriptionContainer: Subscription;

  public containerLg = false;
  public containerMd = false;
  public containerSm = false;
  public activateOverlay = 'none';
  public statusProcessTasks = null;
  public ___statusProcessService: StatusProcessService;

  public socket: Socket;
  private statusProcessTimeout = 3000;

  constructor(
  ) {
    super();
    this.initStorage();
  }

  initStatusProcess() {
    if (!this.statusProcessTasks) {
      this.statusProcessTasks = {
        STATUS_PROCESS_RUNNING: this.checkStatusProcess,
        STATUS_PROCESS_STARTED: this.checkStatusProcess,
        STATUS_PROCESS_FINISHED: this.resultStatusProcess,
        STATUS_PROCESS_FAILED: this.errorStatusProcess,
        STATUS_PROCESS_NOT_FOUND: this.errorStatusProcess,
        STATUS_PROCESS_ERROR: this.errorStatusProcess,
      };
    }
  }

  isSocketConnected() {
    return this.socket && this.socket.connected;
  }

  initSocket() {
    if (this.currentUser && (!this.socket || !this.socket.connected)) {
      console.log('init socket');
      this.socket = io(environment.BASE_URL_SOCKET_IO, {
        transports: ['websocket'],
        reconnectionAttempts: 10,
      });

      this.socket.on('connect', () => {
        // @ts-ignore
        this.socket.emit('join', { id: this.socket.id, app: environment.APP }, (res) => {
          console.log(res);
        });
        console.log('connected');
      });

      this.socket.on('disconnect', () => {
        console.log('disconnected');
      });
    }
  }

  initStorage() {
    this.currentUser = this.getCurrentUser();
    this.localeSettings = this.getLocaleSettings();
    this.customCurrencyMaskConfig = this.getCurrencyMaskSettings();
    localStorage.setItem('uploadMimeTypes', 'application/pdf, image/*, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt, .pptx, text/plain');
  }

  initStatusProcessTasks(statusProcessService: StatusProcessService) {
    this.initStatusProcess();
    this.___statusProcessService = statusProcessService;
  }

  errorStatusProcess(token: string, onSuccess: Callback<any>, onError: Callback<any>) {
    onError(null);
  }

  resultStatusProcess(token: string, onSuccess: Callback<any>, onError: Callback<any>) {
    if (this.isSocketConnected()) {
      this.socket.off(token);
    }
    this.___statusProcessService.getResult(token)
      .subscribe(response => {
        onSuccess(response);
      }, error => {
        onError(error);
      });
  }

  checkStatusProcess(token: string, onSuccess: Callback<any>, onError: Callback<any>, onResponse?: Callback<any>) {
    this.statusProcessTimeout = this.isSocketConnected() ? 6000 : 3000;

    if (this.isSocketConnected()) {
      this.socket.on(token, (response: any, ack: any) => {
        this.statusProcessTasks[response.status].apply(this, [token, onSuccess, onError, onResponse]);
        onResponse(response);
        if (ack) { ack(); }
      });
    }

    // Setting this method as fallback in case of socket.io fails
    setTimeout(() => {
      this.___statusProcessService.getStatus(token)
        .subscribe(response => {
          this.statusProcessTasks[response.status].apply(this, [token, onSuccess, onError, onResponse]);
          if (onResponse) {
            onResponse(response);
          }
        }, error => {
          onError(error);
        });
    }, this.statusProcessTimeout);
  }
}

/**
 * @internal
 */
export class AppContainer extends AppBase {

  @Output()
  public close = new EventEmitter;

  @Output()
  public success = new EventEmitter;

  constructor(public _containerService: ContainerService) {
    super();

    this.subscriptionContainer = this._containerService.observableStateContainer$
      .subscribe(
        res => {
          this.containerLg = false;
          this.containerMd = false;
          this.containerSm = false;
          if (res === 'large') {
            this.containerLg = !this.containerLg;
            this.containerMd = false;
            this.containerSm = false;
            this.activateOverlay = 'block';
          }
          if (res === 'medium') {
            this.containerMd = !this.containerMd;
            this.containerLg = false;
            this.containerSm = false;
            this.activateOverlay = 'block';
          }
          if (res === 'small') {
            this.containerSm = !this.containerSm;
            this.containerLg = false;
            this.containerMd = false;
            this.activateOverlay = 'block';
          }
        });
    this.activateOverlay = 'none';
  }

  public closeContainer(): void {
    this.containerLg = false;
    this.containerMd = false;
    this.containerSm = false;
    this.activateOverlay = 'none';
    this.close.emit();
  }

  public liftSuperimposedContainer(measure: string): void {
    this._containerService.changeStateContainer(measure);
  }
}



// WEBPACK FOOTER //
// ./src/app/app-base.ts